import React, { FC, useEffect, useState, useCallback } from "react";
import {
  Modal,
  Button,
  Input,
  Typography,
  Card,
  Space,
  Tag,
} from "antd";
import {
  FileTextOutlined,
  MessageOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import { errorMessage } from "../../../../utils/notificationUtils";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { QueryService } from "../../../../apis/PreAuthQueryService";
import HistoryModal from "./HistoryModal";
import { HMO_ROLE } from "../../../../utils/hmoRoles";
import QueryResponseDocumentsUpload, {
  buildRequiredDocumentRows,
  type QueryDocumentUploadRow,
} from "../QueryResponseDocumentsUpload";
import type { QueryUploadDocument } from "../../../../utils/queryDocumentUtils";
import "../../patient-list/PatientListModal.css";

const { TextArea } = Input;
const { Text } = Typography;

type UploadQueryModalProps = {
  visible: boolean;
  onClose: () => void;
  replyQuery: any;
  handleOpen: any;
  documentUrls: QueryUploadDocument[];
  onConfirmUpload?: (
    row: QueryDocumentUploadRow,
    file: File,
  ) => Promise<boolean>;
  handleFileChange?: any;
  isReplying: boolean;
  handleSubmit: any;
  setResponseRemark: CallableFunction;
  responseRemark: any;
};

const UploadQueryModal: FC<UploadQueryModalProps> = ({
  visible,
  onClose,
  replyQuery,
  handleOpen,
  documentUrls,
  onConfirmUpload,
  handleFileChange,
  isReplying,
  handleSubmit,
  setResponseRemark,
  responseRemark,
}) => {
  const { auth } = useSelector((state: RootState) => state);
  const [history, setHistory] = useState<any>([]);
  const [historyModal, setHistoryModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [parentQuery, setParentQuery] = useState<any>(null);

  const handleGetHistory = async () => {
    setHistoryModal(true);
    try {
      setIsLoading(true);
      const res = await QueryService.getQueryHistory(
        replyQuery?.id || replyQuery?.queryId,
      );
      setHistory(res);
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setHistory([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetHistoryParentQuery = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await QueryService.getQueryHistory(
        replyQuery?.id || replyQuery?.queryId,
      );
      if (res?.length > 0) {
        const queryData = JSON.parse(res?.[0]?.payloadJson)?.query;
        setParentQuery(queryData.queryQuestion || queryData.receivedQuery);
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setHistory([]);
    } finally {
      setIsLoading(false);
    }
  }, [replyQuery]);

  // useEffect(() => {
  //   if (visible) handleGetHistoryParentQuery();
  // }, [visible, handleGetHistoryParentQuery]);

  return (
    <>
      <Modal
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px 0",
            }}
          >
            <Space>
              <FileTextOutlined style={{ color: "#00549e", fontSize: 18 }} />
              <span style={{ fontSize: 16, fontWeight: 600, color: "#00549e" }}>
                QUERY RECEIVED
              </span>
            </Space>
            {replyQuery?.typeOfQuery === "Payer" && (
              <Button
                type="link"
                icon={<HistoryOutlined />}
                onClick={handleGetHistory}
                style={{
                  color: "#00549e",
                  fontWeight: 500,
                  padding: 0,
                }}
              >
                View History
              </Button>
            )}
          </div>
        }
        open={visible}
        onCancel={onClose}
        footer={null}
        width={1100}
        className="create-query-modal"
        style={{
          borderRadius: 12,
          overflow: "auto",
          top: 2,
          left: 4,
          padding: 0,
        }}
        bodyStyle={{
          // padding: "24px",
          background: "#fafafa",
          overflow: "auto",
          height: "130vh",
        }}
      >
        {/* Query Details Section */}
        <Card
          style={{
            marginBottom: 24,
            borderRadius: 8,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            border: "1px solid #e5e7eb",
          }}
          bodyStyle={{ padding: "20px" }}
        >
          {parentQuery && (
            <div
              style={{
                background: "#f8fafc",
                border: "1px solid #cbd5e1",
                borderRadius: 8,
                padding: 16,
                marginBottom: 16,
                color: "#334155",
                fontSize: 14,
                lineHeight: 1.5,
              }}
            >
              <div
                style={{
                  marginTop: 8,
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                }}
              >
                <div>
                  <Text strong style={{ color: "#1e293b" }}>
                    Main Payer Query:
                  </Text>
                  <div>{parentQuery}</div>
                </div>
              </div>
            </div>
          )}
          <div style={{ marginBottom: 16 }}>
            <Space align="center" style={{ marginBottom: 12 }}>
              <MessageOutlined style={{ color: "#ef4444", fontSize: 16 }} />
              <Text strong style={{ fontSize: 14, color: "#374151" }}>
                QUERY DETAILS
              </Text>
            </Space>
            <div
              style={{
                background: "#fef2f2",
                border: "1px solid #fecaca",
                borderRadius: 8,
                padding: 16,
                color: "#dc2626",
                fontSize: 14,
                lineHeight: 1.5,
              }}
            >
              {/* {replyQuery?.receivedQuery} */}
              <div
                style={{
                  marginTop: 8,
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                }}
              >
                {/* {parentQuery && (
                <div>
                  <Text strong style={{ color: "#b91c1c" }}>
                    Parent Query:
                  </Text>
                  <div>{parentQuery}</div>
                </div>
              )} */}

                {(replyQuery?.updatedRemarks || replyQuery?.receivedQuery) && (
                  // <div>
                  //   <Text strong style={{ color: "#dc2626" }}>
                  //     Received Query:
                  //   </Text>
                  <div>{replyQuery.updatedRemarks || replyQuery.receivedQuery}</div>
                  // </div>
                )}
              </div>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Text style={{ fontSize: 13, color: "#6b7280" }}>
              Type of Query:
            </Text>
            <Tag color="blue" style={{ fontSize: 12, padding: "2px 8px" }}>
              {replyQuery?.typeOfQuery}
            </Tag>
          </div>
        </Card>

        {/* Response Section */}
        {(auth?.role?.role === HMO_ROLE.HMO_PORTAL_USER ||
          auth?.role?.role === HMO_ROLE.HSP_USER) && (
          <Card
            style={{
              marginBottom: 24,
              borderRadius: 8,
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
              border: "1px solid #e5e7eb",
            }}
            bodyStyle={{ padding: "20px" }}
          >
            <Space align="center" style={{ marginBottom: 20 }}>
              <MessageOutlined style={{ color: "#00549e", fontSize: 16 }} />
              <Text strong style={{ fontSize: 14, color: "#374151" }}>
                RESPONSE
              </Text>
            </Space>

            <div>
              <Text
                strong
                style={{
                  fontSize: 13,
                  color: "#374151",
                  marginBottom: 8,
                  display: "block",
                }}
              >
                Response Remarks
              </Text>
              <TextArea
                value={responseRemark}
                onChange={(e) => setResponseRemark(e.target.value)}
                rows={4}
                placeholder="Enter your response remarks here..."
                style={{
                  borderRadius: 6,
                  border: "1px solid #d1d5db",
                  resize: "none",
                }}
              />
            </div>

            {replyQuery?.queryRequiredDocuments?.length ? (
              <QueryResponseDocumentsUpload
                rows={buildRequiredDocumentRows(replyQuery.queryRequiredDocuments)}
                uploads={documentUrls}
                onConfirmUpload={onConfirmUpload}
                onUpload={
                  onConfirmUpload
                    ? undefined
                    : (row, file) =>
                        handleFileChange?.(row.documentType, row.label)({ file })
                }
              />
            ) : null}
          </Card>
        )}

        {/* Action Buttons */}
        {(auth?.role?.role === HMO_ROLE.HMO_PORTAL_USER ||
          auth?.role?.role === HMO_ROLE.HSP_USER) && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 16,
              marginTop: 20,
              paddingTop: 16,
              borderTop: "1px solid #e5e7eb",
            }}
          >
            <Button
              onClick={onClose}
              size="large"
              style={{
                borderColor: "#d1d5db",
                color: "#6b7280",
                borderRadius: 8,
                fontWeight: 500,
                padding: "8px 24px",
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleSubmit}
              loading={isReplying}
              size="large"
              style={{
                backgroundColor: "#00549e",
                borderColor: "#00549e",
                borderRadius: 8,
                fontWeight: 500,
                padding: "8px 24px",
                boxShadow: "0 2px 4px rgba(0,84,158,0.2)",
              }}
            >
              Submit Response
            </Button>
          </div>
        )}
      </Modal>

      <HistoryModal
        visible={historyModal}
        onClose={() => setHistoryModal(false)}
        data={history || []}
        isLoading={isLoading}
      />
    </>
  );
};

export default UploadQueryModal;
